import {SvgIcon, SvgIconProps} from "@material-ui/core";
import * as React from 'react';

// A magic wand with sparkles (Material UI v4 has no wand icon).
class WandIcon extends React.Component<SvgIconProps> {
    public render() {
        return (
            <SvgIcon {...this.props}>
                <path d="M7.5 5.6L10 7 8.6 4.5 10 2 7.5 3.4 5 2l1.4 2.5L5 7zm12 9.8L17 14l1.4 2.5L17 19l2.5-1.4L22 19l-1.4-2.5L22 14zM22 2l-2.5 1.4L17 2l1.4 2.5L17 7l2.5-1.4L22 7l-1.4-2.5zm-7.63 5.29a.996.996 0 0 0-1.41 0L1.29 18.96a.996.996 0 0 0 0 1.41l2.34 2.34c.39.39 1.02.39 1.41 0L16.7 11.05a.996.996 0 0 0 0-1.41l-2.33-2.35zm-1.03 5.49l-2.12-2.12 2.44-2.44 2.12 2.12-2.44 2.44z"/>
            </SvgIcon>
        );
    }
}

export default WandIcon;



// WEBPACK FOOTER //
// ./src/components/svg/wandIcon.tsx